import { useLocation } from 'react-router-dom';

/**
 * Optional map data context access for components outside the React tree
 * This allows access to map data context from non-React code or components
 * that are not wrapped in the MapDataProvider
 */
let mapDataContextValue: any = null;

/**
 * Sets the map data context value for optional access
 */
export const setMapDataContextValue = (value: any) => {
  mapDataContextValue = value;
};

/**
 * Hook that returns a function to mark map layers as stale when needed
 * Only affects cache when in the map editor - uses the more efficient
 * markAllLayersStale instead of clearing the entire cache
 */
export const useClearMapCacheIfNeeded = () => {
  const location = useLocation();
  
  return () => {
    if (location.pathname.startsWith('/editor/map') && mapDataContextValue?.markAllLayersStale) {
      mapDataContextValue.markAllLayersStale();
    }
  };
};
